import { render } from "./BlockedList.vue?vue&type=template&id=3452d23a"
import script from "./BlockedList.vue?vue&type=script&lang=js"
export * from "./BlockedList.vue?vue&type=script&lang=js"

import "./BlockedList.vue?vue&type=style&index=0&id=3452d23a&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__